module.exports = __webpack_public_path__ + "img/home-4.43c0b41d.png";